// extracted by mini-css-extract-plugin
export var answer = "questionsAnswers-module--answer--gGDDt";
export var answerWrapper = "questionsAnswers-module--answerWrapper--wtQlC";
export var card = "questionsAnswers-module--card--HrvFA";
export var cardList = "questionsAnswers-module--cardList--tGaMG";
export var container = "questionsAnswers-module--container--cfR5e";
export var headTitle = "questionsAnswers-module--headTitle--VHflo";
export var icon = "questionsAnswers-module--icon--I+Iht";
export var open = "questionsAnswers-module--open--4Y6ij";
export var question = "questionsAnswers-module--question--bKmFz";
export var rotated = "questionsAnswers-module--rotated--81bl6";
export var title = "questionsAnswers-module--title--mDC73";